import { render, staticRenderFns } from "./userComments.vue?vue&type=template&id=14dfcc7a&lang=pug"
import script from "./userComments.vue?vue&type=script&lang=js"
export * from "./userComments.vue?vue&type=script&lang=js"
import style0 from "./userComments.vue?vue&type=style&index=0&id=14dfcc7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports